module.exports = "../img/marker-icon-2x.png";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/marker-icon-2x.png
// module id = 64
// module chunks = 0